import { render, staticRenderFns } from "./SmartGuidedCamera.vue?vue&type=template&id=56bff3a4&"
import script from "./SmartGuidedCamera.vue?vue&type=script&lang=js&"
export * from "./SmartGuidedCamera.vue?vue&type=script&lang=js&"
import style0 from "./SmartGuidedCamera.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports